import { html, LitElement } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { DebugService } from '../../../../shared/services/debug.service.js';
import { style } from './edit-email.style.js';
import { stratum } from '../../../../../constants/stratum.js';

class RefiEditEmail extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiEditEmail');
    this.applicant = {};
  }

  static properties = {
    showConfirm: { type: Boolean },
    emailsMatch: { type: Boolean },
    applicant: { type: Object, reflect: true },
  };

  static styles = [style];

  render() {
    return html`
      <div class="checkout-email-edit">
        <fs-text-field
          id="checkout-email-edit"
          autocomplete="email"
          name="email"
          type="email"
          class="email"
          value-missing-message="Please enter a valid email address"
          maxLength="250"
          pattern="(.*)@(.*)\\..{1,}"
          required
          @blur="${(ev) => {
            this.dispatchEvent(new CustomEvent('unsaved-fields'));
            this.compareEmails();
            if (ev.target.validity.valid) {
              stratum.publishTag(TagKey.PQ_TEXT_INPUT_FIELD_EDITED_FIELD, {
                replacements: { value: 'emailAddress' },
              });
            } else {
              stratum.publishTag(
                TagKey.PQ_TEXT_INPUT_FIELD_FIELD_VALIDATION_ERROR_MESSAGE,
                {
                  replacements: { value: 'Please enter a valid email address' },
                }
              );
            }
          }}"
          @change="${(ev) => {
            this.changed('emailAddress', ev);
          }}"
          value="${this.applicant.emailAddress}"
          pattern-mismatch-message="Please enter a valid email address"
          autofocus
        >
          Email address
        </fs-text-field>

        ${this.showConfirm
          ? html` <fs-text-field
              class="includes-error-message"
              id="checkout-email-confirm"
              name="checkout-email-confirm"
              type="email"
              value-missing-message="Please enter a valid email address"
              maxLength="250"
              pattern="(.*)@(.*)\\..{1,}"
              required
              @change="${(ev) => this.changed('confirmEmailAddress', ev)}"
              value="${this.applicant.confirmEmailAddress}"
              pattern-mismatch-message="Please enter a valid email address"
              error-message="${!this.emailsMatch
                ? 'Please make sure email addresses match'
                : ''}"
              @blur="${(ev) => {
                this.compareEmails();
                if (ev.target.touched && !this.emailsMatch) {
                  stratum.publishTag(
                    TagKey.PQ_TEXT_INPUT_FIELD_FIELD_VALIDATION_ERROR_MESSAGE,
                    {
                      replacements: {
                        value: 'Please make sure email addresses match',
                      },
                    }
                  );
                } else if (!ev.target.validity.valid) {
                  stratum.publishTag(
                    TagKey.PQ_TEXT_INPUT_FIELD_FIELD_VALIDATION_ERROR_MESSAGE,
                    {
                      replacements: {
                        value: 'Please enter a valid email address',
                      },
                    }
                  );
                } else {
                  stratum.publishTag(TagKey.PQ_TEXT_INPUT_FIELD_EDITED_FIELD, {
                    replacements: { value: 'confirmEmailAddress' },
                  });
                }
              }}"
            >
              Confirm email address
            </fs-text-field>`
          : ``}
      </div>
      <p class="disclosure" ?hidden="${!this.showConfirm}">
        When you provide your email address, we may use it to send you important
        information about your application and account(s), as well as other
        useful products and services.
      </p>
    `;
  }

  changed(name, ev) {
    this.showConfirm = true;
    // if (ev.target.validity.valid) {
    this.applicant[name] = ev?.target?.value.trim();
    // }
    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: {
          name,
          isValid: ev.target.validity.valid,
        },
      })
    );
  }

  compareEmails() {
    // if we need to confirm, compare the emails and bubble up the validity result
    if (this.showConfirm) {
      const emailField = this.shadowRoot.getElementById('checkout-email-edit');
      const confirmEmailField = this.shadowRoot.getElementById(
        'checkout-email-confirm'
      );
      this.emailsMatch =
        emailField.value.trim().toLowerCase() ===
        confirmEmailField.value.trim().toLowerCase();
      this.dispatchEvent(
        new CustomEvent('validity', {
          detail: {
            name: 'compareEmails',
            isValid: this.emailsMatch,
          },
        })
      );
      this.dispatchEvent(
        new CustomEvent('validity', {
          detail: {
            name: 'confirmEmailAddress',
            isValid: this.emailsMatch,
          },
        })
      );
    }
  }
}

customElements.define('refi-edit-email', RefiEditEmail);
